import type { ApiQuestion } from '../../../../internalTypes';
import type { QuestionMedia } from '../../../../types/shared';
import { getConfigValue } from '../shared/configUtils';
import { mapContainerMedia, resolveMediaMimeType } from '../shared/mapQuestionMedia';

export function buildMediaConfig(question: ApiQuestion): QuestionMedia {
  const add = question.additional ?? {};

  let url = (add['mediaUrl'] as string | undefined) ?? (add['previewUrl'] as string | undefined);
  let mimeType = add['mediaMimeType'] as string | undefined;
  let title = add['title'] as string | undefined;
  let previewUrl: string | undefined;

  const assets = question.questionContainerAssets;
  if (Array.isArray(assets) && assets.length > 0) {
    const asset = assets[0];
    if (asset.source || asset.previewImageUrl) {
      url = asset.source || asset.previewImageUrl;
    }
    if (asset.previewImageUrl) {
      previewUrl = asset.previewImageUrl;
    }
    if (asset.name) {
      title = asset.name;
    }
    const inferredMime = resolveMediaMimeType(asset);
    if (inferredMime) {
      mimeType = inferredMime;
    }
  }

  const configs = question.questionConfigs || [];
  const alignConfig = configs.find(c => c.key === 'TEXT_AND_MEDIA_ALIGNMENT');
  const sizeConfig = configs.find(c => c.key === 'TEXT_AND_MEDIA_SIZE');
  const alignment = alignConfig?.value?.[0];
  const size = sizeConfig?.value?.[0] ? Number(sizeConfig.value[0]) : undefined;
  const altText = getConfigValue(configs, 'TEXT_AND_MEDIA_ALT_TEXT');

  const fromContainer = mapContainerMedia(question, configs);

  return {
    ...(url ? { url } : fromContainer?.url ? { url: fromContainer.url } : {}),
    ...(previewUrl ? { previewUrl } : fromContainer?.previewUrl ? { previewUrl: fromContainer.previewUrl } : {}),
    ...(mimeType ? { mimeType } : fromContainer?.mimeType ? { mimeType: fromContainer.mimeType } : {}),
    ...(title ? { title } : fromContainer?.title ? { title: fromContainer.title } : {}),
    ...(alignment ? { alignment } : {}),
    ...(size !== undefined && !Number.isNaN(size) ? { size } : {}),
    ...(altText ? { altText } : fromContainer?.altText ? { altText: fromContainer.altText } : {}),
  };
}
